const { default: axios } = require("axios");
const { Swiper } = require('swiper/bundle');
const { Notyf } = require('notyf');
require('swiper/css/bundle');

const Lia = function () {

    let activeLiaChannelName = null;
    let liaChannel = null;
    let isUnloadBound = false;
    let notyf = null;
    let isChannelActive = false;

    const cleanupLiaChannel = () => {
        if (liaChannel && typeof liaChannel.stopListening === 'function') {
            liaChannel.stopListening('LiaUpdateBoxEvent');
            liaChannel.stopListening('LiaInteractionEvent');
            liaChannel.stopListening('LiaOpportunityEvent');
            liaChannel.stopListening('LiaTicketEvent');
            liaChannel.stopListening('LiaMessageEvent');
        }

        if (activeLiaChannelName && typeof Echo !== 'undefined' && typeof Echo.leave === 'function') {
            Echo.leave(activeLiaChannelName);
        }

        activeLiaChannelName = null;
        liaChannel = null;
        isChannelActive = false;
    };

    const getLiaEventUrl = () => {
        const $liaEvent = $('#lia-event');
        return $liaEvent.length > 0 ? $liaEvent.data('lia_event') : null;
    };

    const getNotyf = () => {
        if (!notyf) {
            notyf = new Notyf({
                duration: 10000,
            });
        }

        return notyf;
    };

    const hasLiaEventContext = () => $('#lia-event').length > 0;

    const playNotificationAudio = () => {
        const audioNotification = document.getElementById('audio-notification');
        if (audioNotification) {
            audioNotification.play().catch(() => { });
        }
    };

    const upsertLastChatMessageCard = (card) => {
        const $newCard = $(card.html);
        const newCardId = $newCard.attr('id');
        const $existing = $(card.target).add(newCardId ? '#' + newCardId : []);

        if ($existing.length > 0) {
            $existing.remove();
        } else if ($('#last-chat-messages .item-last-message').length >= 4) {
            $('#last-chat-messages .item-last-message').last().remove();
        }

        $('#last-chat-messages').prepend($newCard);
        $('.total-message-not-read').text(card.total);

        if ($('#last-chat-messages .item-last-message').length > 0) {
            $('#p-no-messages').removeClass('d-block').addClass('d-none');
        } else {
            $('#p-no-messages').removeClass('d-none').addClass('d-block');
        }
    };

    const postLiaEvent = (payload, onSuccess) => {
        const url = getLiaEventUrl();
        if (!url) {
            return false;
        }

        axios.post(url, payload).then(function (responseAxios) {
            const data = responseAxios.data;
            if (data.error == false && typeof onSuccess === 'function') {
                onSuccess(data);
            }
        });

        return true;
    };

    const handleLiaUpdateBoxEvent = (response) => {
        let opportunity_id = response.opportunity_id;
        let search = $('.lia-container').find('div[data-opportunity_id="' + opportunity_id + '"]');

        if (search.length === 0) {
            return;
        }

        let searchRecord = search.closest('.lia-records');
        let loadCard = search.closest('.load-card');
        let src = loadCard.attr('data-src');

        let ignoreOpportunities = [];
        searchRecord.find('.box-opp-lia').each(function () {
            let opportunity = $(this);
            ignoreOpportunities.push(opportunity.attr('data-opportunity_id'));
        });

        axios.post(src, {
            'limit': 1,
            'ignore_opportunities': ignoreOpportunities
        }).then((response) => {
            let data = response.data;

            if (data.error == false) {
                let result = JSON.parse(data.result.html);
                let html = result.html;
                let total = result.total;

                search.addClass('hideCardLia');

                setTimeout(() => {
                    search.hide(0, function () {
                        search.closest('.lia-records').find('.swiperOppLia').find('.swiper-wrapper').append(html);

                        let currentTotal = search.closest('.lia-records');
                        let currentLength = currentTotal.find('.box-opp-lia').not('.hideCardLia').length;

                        currentTotal.closest('.card-parent-lia').find('.data-totcurrent').text(currentLength);
                        search.closest('.card-parent-lia').find('.data-totnow').text(total);

                        $(this).closest('.swiper-slide').remove();
                        $(this).remove();
                        galleryScroll();
                    });
                }, 1500);
            }
        });
    };

    const handleLiaInteractionEvent = (response) => {
        if (!hasLiaEventContext()) {
            return false;
        }

        const payload = { ...response, environment: 'interaction' };
        return postLiaEvent(payload, (data) => {
            if (data.notification) {
                getNotyf().success(data.notification);
                playNotificationAudio();
            }
        });
    };

    const handleLiaOpportunityEvent = (response) => {
        if (!hasLiaEventContext()) {
            return false;
        }

        const payload = { ...response, environment: 'opportunity' };
        return postLiaEvent(payload, (data) => {
            if (data.notification) {
                getNotyf().success(data.notification);
                playNotificationAudio();
            }
        });
    };

    const handleLiaTicketEvent = (response) => {
        if (!hasLiaEventContext()) {
            return false;
        }

        const payload = { ...response, environment: 'ticket' };

        let method = '';
        let ticketsId = [];
        if (payload.action == 'update' || payload.action == 'update-response') {
            if ($('div#ticket-id-' + payload.ticket_id).length > 0) {
                method = $('div#ticket-id-' + payload.ticket_id).closest('.lia-tickets').data('method');
            }
            if (method.length > 0) {
                $('#' + method).find('.ticket-opp').each(function () {
                    ticketsId.push($(this).data('id'));
                });
                payload.tickets_id = ticketsId;
                payload.method = method;
            }
        }

        return postLiaEvent(payload, (data) => {
            let result = data.result;

            if (data.notification) {
                getNotyf().success(data.notification);
                playNotificationAudio();
            }

            if (payload.action == 'create') {
                if (result.new_ticket) {
                    if ($('#tickets-for-today > div').length >= 4) {
                        $('#tickets-for-today > div').last().remove();
                    }
                    $('#tickets-for-today').prepend(result.new_ticket.html);

                    $('#tickets-for-today').closest('.load-card').find('.data-totnow').text(result.new_ticket.total);
                    $('#tickets-for-today').closest('.load-card').find('.data-totcurrent').text($('#tickets-for-today .col').length);
                    $('#tickets-for-today').closest('.load-card').find('.p-empty-tickets-all').removeClass('d-block').addClass('d-none');
                }

                $('.load-card').addClass('no-load');
                loadCard();

            } else if (result.remove_ticket) {
                $(result.remove_ticket.target).remove();
                if (result.new_ticket) {
                    $('#' + method).append(result.new_ticket.html);
                }

                $('#' + method).closest('.load-card').find('.data-totnow').text(result.remove_ticket.total);
                $('#' + method).closest('.load-card').find('.data-totcurrent').text($('#' + method + ' .col').length);
            } else if (result.update_all_cards) {
                $('.load-card').addClass('no-load');
                loadCard();
            }

            if ($('#' + method).length > 0) {
                if ($('#' + method).find('>div:not(.p-empty-tickets-all)').length > 0) {
                    $('#' + method).find('.p-empty-tickets-all').removeClass('d-block').addClass('d-none');
                } else {
                    $('#' + method).find('.p-empty-tickets-all').removeClass('d-none').addClass('d-block');
                }
            }
        });
    };

    const loadCard = () => {
        let element = $('.load-card.no-load').eq(0);
        if (element.length == 0) {
            return false;
        }

        let src = element.data('src');
        axios.post(src, $('.form-ajax-dashboard').serialize())
            .then(function (response) {
                let data = response.data;

                if (data.error === false) {

                    element.html(data.result.html);

                    // if (element.closest('.lia-container').length > 0) {
                    //     galleryScroll();
                    // }
                }

                element.removeClass('no-load');
                loadCard();
            });

    }

    const handleLiaMessageEvent = (response) => {
        if (!hasLiaEventContext() || response?.action === 'update-event') {
            return false;
        }

        const payload = { ...response, environment: 'message' };
        return postLiaEvent(payload, (data) => {
            let result = data.result;

            if (data.notification) {
                getNotyf().success(data.notification);
                playNotificationAudio();
            }

            if (result.remove_message) {
                $(result.remove_message.target).remove();
            }

            if (result.unread_messages) {
                $(result.unread_messages.target).remove();
                $('.total-message-not-read').text(result.unread_messages.total);

                if ($('#last-chat-messages .item-last-message').length > 0) {
                    $('#p-no-messages').removeClass('d-block').addClass('d-none');
                } else {
                    $('#p-no-messages').removeClass('d-none').addClass('d-block');
                }

                if (result.new_message) { return; }
            }

            if (result.create) {
                upsertLastChatMessageCard(result.create);
            }

            if (result.new_message) {
                upsertLastChatMessageCard(result.new_message);
            }
        });
    };

    const registerChannelListeners = (channel) => {
        return channel
            .listen('LiaUpdateBoxEvent', handleLiaUpdateBoxEvent)
            .listen('LiaInteractionEvent', handleLiaInteractionEvent)
            .listen('LiaOpportunityEvent', handleLiaOpportunityEvent)
            .listen('LiaTicketEvent', handleLiaTicketEvent)
            .listen('LiaMessageEvent', handleLiaMessageEvent);
    };

    const destroy = () => {
        if (typeof window !== 'undefined' && isUnloadBound) {
            window.removeEventListener('beforeunload', destroy);
            window.removeEventListener('pagehide', destroy);
            isUnloadBound = false;
        }

        cleanupLiaChannel();
    };

    const bindUnloadCleanup = () => {
        if (typeof window === 'undefined' || isUnloadBound) {
            return;
        }

        window.addEventListener('beforeunload', destroy);
        window.addEventListener('pagehide', destroy);
        isUnloadBound = true;
    };

    const startWS = () => {
        if (typeof Echo === 'undefined' || user_logged_id == 0) {
            return;
        }

        const channelName = `lia.${client_name}`;
        if (isChannelActive && activeLiaChannelName === channelName && liaChannel) {
            return;
        }

        cleanupLiaChannel();
        bindUnloadCleanup();

        activeLiaChannelName = channelName;
        liaChannel = registerChannelListeners(Echo.private(channelName));
        isChannelActive = true;
    }

    const textIntroLia = () => {
        // values to keep track of the number of letters typed, which quote to use. etc. Don't change these values.
        var i = 0,
            a = 0,
            isBackspacing = false,
            isParagraph = false;

        // Typerwrite text content. Use a pipe to indicate the start of the second line "|".  
        let titleWrite = $('.textWriting').find('[data-titlewrite]').attr('data-titlewrite');
        let textWrite = $('.textWriting').find('[data-textwrite]').attr('data-textwrite');
        var textArray = [titleWrite + "|" + textWrite];

        // Speed (in milliseconds) of typing.
        var speedForward = 50, //Typing Speed
            speedWait = 1000, // Wait between typing and backspacing
            speedBetweenLines = 1000, //Wait between first and second lines
            speedBackspace = 25; //Backspace Speed

        //Run the loop
        typeWriter("textWriting", textArray);

        function typeWriter(id, ar) {
            var element = $("#" + id),
                aString = ar[a],
                eHeader = element.find("[data-titlewrite]"), //Header element
                eParagraph = element.find("[data-textwrite]"); //Subheader element

            // Determine if animation should be typing or backspacing
            if (!isBackspacing) {

                // If full string hasn't yet been typed out, continue typing
                if (i < aString.length) {

                    // If character about to be typed is a pipe, switch to second line and continue.
                    if (aString.charAt(i) == "|") {
                        isParagraph = true;
                        eHeader.removeClass("cursorWrite");
                        eParagraph.addClass("cursorWrite");
                        i++;
                        setTimeout(function () { typeWriter(id, ar); }, speedBetweenLines);

                        // If character isn't a pipe, continue typing.
                    } else {
                        // Type header or subheader depending on whether pipe has been detected
                        if (!isParagraph) {
                            eHeader.text(eHeader.text() + aString.charAt(i));
                        } else {
                            eParagraph.text(eParagraph.text() + aString.charAt(i));
                        }
                        i++;
                        setTimeout(function () { typeWriter(id, ar); }, speedForward);
                    }

                    // If full string has been typed, switch to backspace mode.
                } else if (i == aString.length) {

                    isBackspacing = true;
                    setTimeout(() => {
                        eParagraph.removeClass('cursorWrite');
                    }, 800);
                    // setTimeout(function(){ typeWriter(id, ar); }, speedWait);

                }

                // If backspacing is enabled
            } else {

                // If either the header or the paragraph still has text, continue backspacing
                if (eHeader.text().length > 0 || eParagraph.text().length > 0) {

                    // If paragraph still has text, continue erasing, otherwise switch to the header.
                    if (eParagraph.text().length > 0) {
                        eParagraph.text(eParagraph.text().substring(0, eParagraph.text().length - 1));
                    } else if (eHeader.text().length > 0) {
                        eParagraph.removeClass("cursor");
                        eHeader.addClass("cursor");
                        eHeader.text(eHeader.text().substring(0, eHeader.text().length - 1));
                    }
                    setTimeout(function () { typeWriter(id, ar); }, speedBackspace);

                    // If neither head or paragraph still has text, switch to next quote in array and start typing.
                } else {

                    isBackspacing = false;
                    i = 0;
                    isParagraph = false;
                    a = (a + 1) % ar.length; //Moves to next position in array, always looping back to 0
                    setTimeout(function () { typeWriter(id, ar); }, 50);

                }
            }
        }

    }

    const galleryScroll = () => {

        // return;

        let _galleryScroll = ".swiperOppLia";

        $(_galleryScroll).each(function (e) {

            const _galleryScroll = $(this);
            let _parent = _galleryScroll.closest('.row-gallery');
            let nameGal = 'gal-lia';//_galleryScroll.data('name');

            // if(_galleryScroll.find('.swiper-slide').length < 4) {
            //     _galleryScroll.find('.swiper-slide').find('.box-opp-lia').addClass('col-md-3');
            // };

            _galleryScroll.addClass('swiper-container-' + nameGal + '-' + e);
            _parent.find('.swiper-button-prev').addClass('swiper-button-prev-' + nameGal + '-' + e);
            _parent.find('.swiper-button-next').addClass('swiper-button-next-' + nameGal + '-' + e);
            _parent.find('.swiper-pagination').addClass('swiper-pagination-' + nameGal + '-' + e);
            _parent.find('.swiper-scrollbar').addClass('swiper-scrollbar-' + nameGal + '-' + e);

            if ($('.swiper-container-' + nameGal + '-' + e).find('picture').length <= 1) {
                $('.swiper-container-' + nameGal + '-' + e).closest('.row-gallery').find('.wrap-navigation-custom').hide();
            }

            const galSwiper = '.swiper-container-' + nameGal + '-' + e;

            // init Swiper:
            new Swiper(galSwiper, {
                speed: 1000,
                loop: false,
                autoHeight: true,
                slidesPerView: 1,
                spaceBetween: 30,
                effect: 'slide',
                autoplay: false,
                breakpoints: {
                    1250: {
                        slidesPerView: 4,
                    },
                    768: {
                        slidesPerView: 3,
                    },
                    500: {
                        slidesPerView: 2,
                    },
                }
            });

        });

    }

    return {

        galleryScroll: galleryScroll,

        init: () => {
            destroy();
            startWS();
            textIntroLia();
            galleryScroll();
        },

        destroy: () => {
            destroy();
        }
    }

}();

module.exports = Lia;